<template>
  <b-container>
    <b-row class="d-flex justify-content-center">
      <b-col md="10" lg="8" xl="6" v-if="user">
        <h1>
          {{
            user.user_type.charAt(0).toUpperCase() + user.user_type.substr(1)
          }}
          Profile
        </h1>

        <div class="box profile">
          <img
            class="img-fluid img-profile rounded-circle mb-16"
            :src="user.avatar"
            :alt="`${user.first_name} ${user.last_name}`"
          />

          <div class="display-4 mb-8">
            {{ user.first_name }} {{ user.last_name }}
          </div>

          <p>{{ user.bio }}</p>

          <ul class="list-inline">
            <li
              class="list-inline-item"
              v-for="expertise in user.expertise.filter((el) => el)"
              :key="expertise.skill_id"
            >
              <b-badge variant="light">
                {{ expertise.title.split(' ')[0] }}
              </b-badge>
            </li>
          </ul>

          <div v-if="user.experience">
            <b-badge variant="highlight">
              {{
                experience[user.experience]
                  ? experience[user.experience]
                  : user.experience
              }}
            </b-badge>
          </div>

          <div v-if="user.company_name">
            <hr />

            <div class="current-project">
              <h4 class="text-primary">Current Project</h4>

              <h6>{{ user.company_name }}</h6>

              <p>
                <em>{{ user.company_description }}</em>
              </p>

              <p>
                {{ user.company_role }}
              </p>

              <!-- <ul class="list-inline">
                <li
                  class="list-inline-item"
                  v-for="need in user.company_needs.filter(el => el)" :key="need"
                >
                  <b-badge variant="light">
                    {{ areas[ need ] ? areas[ need ] : expertise }}
                  </b-badge>
                </li>
              </ul> -->

              <p v-if="user.company_url">
                <a
                  class="btn btn-xs btn-outline-secondary"
                  :href="createClickableUrl(user.company_url)"
                  target="_blank"
                >
                  More Info
                </a>
              </p>
            </div>
          </div>

          <div>
            <hr />

            <b-btn
              class="mr-3"
              variant="secondary"
              v-if="
                $auth.user().user_type === 'entrepreneur' &&
                  user.user_type === 'advisor'
              "
              @click="toggleAdvisorStatus"
            >
              <!-- <span v-if="advisoryBoardId != null">Remove from</span><span v-else>Add to</span> Advisory Board -->
              {{ advisorButtonTitle() }}
            </b-btn>

            <b-btn variant="primary" @click="showScheduleModal = true">
              Book Meeting
            </b-btn>

            <schedule-modal
              :show="showScheduleModal"
              :user="user"
              @dismiss="showScheduleModal = false"
            />
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import ScheduleModal from '@/components/advisors/ScheduleModal'

export default {
  name: 'UsersProfile',
  components: {
    ScheduleModal,
  },
  data() {
    return {
      user: null,
      areas: {
        finance: 'Finance',
        legal: 'Legal',
        hr: 'HR',
        strategy: 'Strategy',
        ops: 'Ops',
        tech: 'Tech',
        sales: 'Mktg/Sales',
        buySell: 'Buy/Sell',
        franchising: 'Franch',
        international: 'Intl',
        government: 'Govt',
      },
      experience: {
        lt_1: '< 1 year',
        '1_5': '1-5 years',
        '5_10': '5-10 years',
        '10_20': '10-20 years',
        '20p': '20+ years',
      },
      showScheduleModal: false,
      advisoryBoardId: null,
      advisoryPending: null,
    }
  },
  mounted() {
    this.$http.get(`users/${this.$route.params.uuid}`).then(
      (res) => {
        this.user = res.data.data
        this.checkAdvisorStatus()
      },
      () => {
        this.$router.push('/')
      }
    )
  },
  methods: {
    toggleAdvisorStatus() {
      let ep = ''
      // Need to handle cancel, remove and invite together. TS support soon, pls
      const isInvite = this.advisoryBoardId == null
      const isCancel = this.advisoryPending == true
      if (isInvite) {
        ep = 'invite'
      } else if (isCancel) {
        ep = 'cancel'
      } else {
        ep = 'remove'
      }
      // Cancel and remove are both based on the id of the advisory board, not the underlying user
      const id = !isInvite ? this.advisoryBoardId : this.user.uuid
      this.$http.post(`advisory_board/${ep}/${id}`).then(
        (res) => {
          if (res.data.error) {
            this.$bvModal.msgBoxOk(res.data.error, {
              centered: true,
              title: 'Error',
            })
          } else {
            this.showAdvisorSuccessAlert(isInvite, isCancel)
          }
        },
        () => {}
      )
    },
    showAdvisorSuccessAlert(isInvite, isCancel) {
      let alertTitle = ''
      let alertMessage = ''
      if (isCancel) {
        alertTitle = 'Invitation cancelled'
        alertMessage = 'Advisory board invitation cancelled'
      } else {
        const messageAction = isInvite ? 'invited to' : 'removed from'
        const titleAction = isInvite ? 'Invited to' : 'Removed from'
        alertTitle = `${titleAction} Advisory Board`
        alertMessage = `This user has been ${messageAction} your advisory board`
      }
      this.$bvModal.msgBoxOk(
          alertMessage,
          {
            centered: true,
            title: alertTitle,
          }
        )
        this.refreshAdvisors()
    },
    advisorButtonTitle() {
      // Check for status/advisoryboard id
      if (this.advisoryBoardId == null) {
        return 'Add to Advisory Board'
      }

      return this.advisoryPending === true
        ? 'Cancel Invitation'
        : 'Remove from Advisory Board'
    },
    createClickableUrl(url) {
      if (url.length > 0 && !url.startsWith('http')) {
        return 'https://' + url
      }
      return url
    },
    refreshAdvisors() {
      this.$advisoryBoardService.getAdvisoryBoard(true).then(() => {
        this.checkAdvisorStatus()
      })
    },
    // Method for finding if user is advisor on board, maybe just return advisory_board id and null check?
    checkAdvisorStatus() {
      this.$advisoryBoardService
        .advisoryBoardFor(this.user.uuid)
        .then((board) => {
          if (board != null) {
            this.advisoryBoardId = board.uuid
            this.advisoryPending = board.status == 'pending'
          } else {
            this.advisoryBoardId = null
            this.advisoryPending = false
          }
        })
    },
  },
}
</script>

<style scoped>
.profile {
  text-align: center;
  font-size: 0.875rem;
}

.img-profile {
  width: 96px;
  height: 96px;
}

.profile .current-project {
  border: none;
  margin: 0;
  padding: 0;
}

.profile .current-project p {
  margin-bottom: 0.5rem;
}
</style>
